export default __webpack_public_path__ + "static/lean-on-phone-illustration-6f2a82e75fa8c95eefc6ea3592291a33.png";